<template>
  <div class="h-full flex">
    <div class="relative w-1/2 h-full">
      <LoadingGUI></LoadingGUI>
      <MatCapPreview @onLoop="onLoop = $event">
        <GameNPC v-if="reset" :matcap="matcap" :char="char" :key="char" :dance="dance"></GameNPC>
      </MatCapPreview>
    </div>
    <div class="w-1/2 h-full overflow-scroll scrolling-touch block flex-wrap justify-between items-center">
      <div>
        Hold Shift Key to enable hover preview.
      </div>

      <div>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="reset = false; matcap = false; $nextTick(() => { reset = true })">Reset</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'swat'">Swat</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'mann-mid-poly'">Glass</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'suzie'">Suzie</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'david'">David</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'ricky'">Ricky</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'joe'">Joe</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'girl'">Girl</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'frank'">Frank</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'alex'">Alex</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-orange-100" @click="char = 'steve'">Steve</button>
      </div>

      <div>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Warming Up'">Warming Up</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Breakdance Freezes'">Breakdance Freezes</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Breakdance Freeze Var 2'">Breakdance Freeze 2</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Breakdance Ready'">Breakdance Ready</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Brooklyn Uprock'">Brooklyn Uprock</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'flair (2)'">Flair</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Mma Idle'">Mma Idle</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Taunt'">Taunt</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'control standing idle'">Idle</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'control standing idle old2'">Idle 2</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Thriller Part 4'">Thriller Part 4</button>
        <button class="mb-1 mr-1 border py-1 px-2 text-xs bg-blue-100" @click="dance = 'Hip Hop Dancing (10)'">Hip Hop Dancing</button>
      </div>
      <div class="text-xs">
        Credit:
        <a class="underline mr-1" href="https://github.com/nidorx/matcaps" target="_blank"> https://github.com/nidorx/matcaps</a>
        <a class="underline mr-1" href="https://www.mixamo.com/#/" target="_blank"> https://www.mixamo.com/#/</a>
      </div>

      <div class="inline-block w-16 h-16 m-n6 cursor-pointer bg-red-300 border-white border" @mouseenter="() => { if (isShift) { useAnimated() } }" v-if="ready" @click="useAnimated"></div>

      <div class="inline-block w-16 h-16 m-n6" :key="item.key" v-for="item in lib.list">
        <img class="cursor-pointer" v-if="ready" @click="loadMatCapToModel(item.url)" @mouseenter="() => { if (isShift) { loadMatCapToModel(item.url) } }" :src="item.blob" :alt="item.key">
        <div v-show="!ready" class="w-16 h-16 bg-gray-300 border-white border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { MatCaps } from './MatCaps'
import { AnimatedMatCap } from './AnimatedMatCap'
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  data () {
    let lib = new MatCaps()
    return {
      onLoop: false,
      reset: true,
      dance: 'Warming Up',
      char: 'swat',
      lib,
      isShift: false,
      matcap: false,
      ready: false
    }
  },
  async mounted () {
    await this.lib.preloadAll()
    this.ready = true
    window.addEventListener('keydown', (evt) => {
      this.isShift = evt.shiftKey
    })
    window.addEventListener('keyup', () => {
      this.isShift = false
    })
  },
  methods: {
    async useAnimated () {
      this.matcap = new AnimatedMatCap({ onLoop: this.onLoop })
    },
    async loadMatCapToModel (url) {
      this.matcap = await this.lib.loadMatCap(url)
    }
  }
}
</script>

<style lang="postcss">
.h-half{
  height: 50%;
}
@screen lg {
  .m-n6{
    margin-bottom: -6px;
  }
  .h-half{
    height: unset;
  }
}
</style>